module.exports = __webpack_public_path__ + "img/basketball_gif.7dab2e2c.gif";